import { createContext } from 'react'

/** @type {import('react').Context<import('./types').ToastApi | null>} */
export const ToastContext = createContext(null)
